const COLOR_MAP = {
  registered: '--color-green-400',
  invited: '--color-blue-400',
  notYetInvited: '--color-red-500',
  declined: '--color-red-400',
  default: '--color-green-400',
};

export { COLOR_MAP };
